import { createFileRoute } from "@tanstack/react-router";
import { SocialMediaMarketingServicePage } from "./services_.social-media-marketing";

export const Route = createFileRoute("/services_/social-media-marketing-services")({
  head: () => ({
    meta: [
      {
        title: "Social Media Marketing Services — KMWAdvertising",
      },
      {
        name: "description",
        content: "Full-Funnel Social Media Strategy & Community Growth.",
      },
    ],
  }),
  component: SocialMediaMarketingServicePage,
});
